export default __webpack_public_path__ + "static/_/_/legos/assets/lib/shared/icon/allstar/allstar-logo-purple.webp";